import React, { useState } from 'react';
// Modules
import moment from 'moment';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
// Context
import { useLogsData } from '../../../context/LogsContext';
// Components
import DefaultModal from '../../../components/modal/DefaultModal';
import { NoData } from '../../../components/table/components/NoData';
import LogForm from './LogForm';
import PartnerIcons from './PartnerIcons';
// Icons
import { FaPencilAlt } from 'react-icons/fa';

// Enums
import { serviceOrigin, serviceOriginLabelCard, servicePartnerLabel } from '../../../utils/Enums';

const LogsCard = () => {
  // Context
  const { state } = useLogsData();

  // State
  const [showModal, setModalShow] = useState(false);
  const [log, setLog] = useState({});

  // Methods
  const cleanUsername = (name) => {
    let cleanName;
    let splitName;
    cleanName = name.replace('IMP-WEB01\\', '');
    splitName = cleanName.split('.');
    for (var i = 0; i < splitName.length; i++) {
      splitName[i] = splitName[i].charAt(0).toUpperCase() + splitName[i].slice(1);
    }
    cleanName = splitName.join(' ');
    return cleanName;
  };
  const handleShowModal = () => setModalShow(true);

  const handleCloseModal = () => setModalShow(false);

  const handleEditLog = (row) => {
    handleShowModal();
    setLog(row);
  };

  return (
    <>
      {state.data.items != null && (
        <Row className="card--sub-header-main">
          <Col lg={8}>
            <h6>Cliente</h6>
          </Col>
          <Col>
            <h6>Contracto</h6>
          </Col>
          <Col>
            <h6>Validado</h6>
          </Col>
        </Row>
      )}
      {state.data.items !== null && state.data.items.length > 0 ? (
        state.data.items.map((data, index) => (
          <Row key={index} className="card-main">
            <Col lg={8} className="card-main--division">
              <Row>
                <Col lg={2} className="card-main--col">
                  <span>
                    <PartnerIcons icon={data.serviceTypeId} />
                    {servicePartnerLabel[data.partnerId]}
                  </span>
                </Col>
                <Col lg={5} className="card-main--col">
                  <p className="fw-medium">{data.subsidiaryCommercialDesignation}</p>
                  <p>{data.userName}</p>
                  <p>
                    <span>NIPC</span>
                    {data.subsidiaryVatNumber}
                    <span> Contacto</span>
                    {data.userPhone}
                  </p>
                </Col>
                <Col lg={3} className="card-main--col">
                  <p>
                    <span>Registo</span>
                    {moment(data.startDate).format('DD-MM-YYYY')}
                  </p>
                  <p>
                    <span>Submissão</span>
                    {data.submissionDate ? moment(data.submissionDate).format('DD-MM-YYYY') : <></>}
                  </p>
                </Col>
                <Col lg={2} className="card-main--col data--origin-type">
                  <span className={`${data.originId === serviceOrigin.MANUAL ? 'type-manual' : 'type-site'}`}>
                    {serviceOriginLabelCard[data.originId]}
                  </span>
                </Col>
              </Row>
            </Col>
            <Col className="card-main--division">
              <p>
                <span>Inicio</span>
                {data.agreementDate ? moment(data.agreementDate).format('DD-MM-YYYY') : <></>}
              </p>
              <p>
                <span>Benefício</span>
                {data.benefitValue}€
              </p>
            </Col>
            <Col>
              <p>
                <span>Data</span>
                {data.validationDate ? moment(data.validationDate).format('DD-MM-YYYY') : <></>}
              </p>
              <p>
                <span>Comercial</span>
                {data.validationBy ? cleanUsername(data.validationBy) : <></>}
              </p>
            </Col>
            <div className="card-main--action">
              <span onClick={() => handleEditLog(data)}>
                <FaPencilAlt />
              </span>
            </div>
          </Row>
        ))
      ) : (
        <NoData />
      )}
      <DefaultModal title={'Editar'} log={log} showModal={showModal} handleCloseModal={handleCloseModal}>
        <LogForm log={log} handleCloseModal={handleCloseModal} />
      </DefaultModal>
    </>
  );
};

export default LogsCard;
